import { Component, Input, OnInit } from '@angular/core';
import { TicketDto } from '../../../../../service/dto';

class Question {
	title!: string;
	answers!: string[];
}

@Component({
	selector: 'app-ticket-questionnaire-view',
	standalone: false,
	templateUrl: './ticket-questionnaire-view.component.html',
	styleUrl: './ticket-questionnaire-view.component.scss'
})
export class TicketQuestionnaireViewComponent implements OnInit {
	@Input() ticket!: TicketDto;
	questions: Question[] = [];

	ngOnInit(): void {
		const questionMap = new Map<number, Question>();

		// 1. Build questions from template
		this.ticket.questionnaireTemplate!.sections!.forEach(section => {
			section.elements!.forEach(element => {
				questionMap.set(element.id, {
					title: element.label,
					answers: []
				});
			});
		});

		// 2. Loop questionnaires in order (preserves answer order)
		this.ticket.questionnaires!.forEach(questionnaire => {
			questionnaire.step!.sections!.forEach(section => {
				section.elements!.forEach(element => {
					const question = questionMap.get(element.id);
					if (question) {
						question.answers.push(element.value ?? '');
					}
				});
			});
		});

		// 3. Convert map to array (preserves template order)
		this.questions = Array.from(questionMap.values());
	}
}
